import React from "react";
import '../css/HomeContent.css';

function HomeScreen() {
    const features = [
      {
        title: "Real-Time Collaboration",
        description:
          "Collaborate with team members in real-time with instant updates and comments.",
        icon: "fas fa-users",
      },
      {
        title: "Code Compilation",
        description:
          "Compile and run code within the editor for quick feedback and debugging.",
        icon: "fas fa-code",
      },
      {
        title: "Chat Space",
        description:
          "Communicate with team members via a built-in chat feature for seamless collaboration.",
        icon: "fas fa-comments",
      },
      
    ];
    const Uses = [
        {
            title: "Interview Candidates",
            description:
              "Conduct live coding interviews with candidates to assess their skills in real-time.",
            icon: "fas fa-user-tie",
          },
          {
            title: "Teach Programming",
            description:
              "Share documents and work collaboratively with students to facilitate learning.",
            icon: "fas fa-chalkboard-teacher",
          },
          {
            title: "Pair Programming",
            description:
              "Collaborate with a partner in real-time to write and debug code together.",
            icon: "fas fa-handshake",
          },
    ];
  
    return (
      <div className="home-screen">
        <h1>Features</h1>
        <div className="features">
          {features.map((feature) => (
            <div className="feature-card">
              <div className="icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
       <h1> Uses </h1>
        <div className="features">
          {Uses.map((Uses) => (
            <div className="feature-card">
              <div className="icon">
                <i className={Uses.icon}></i>
              </div>
              <h3>{Uses.title}</h3>
              <p>{Uses.description}</p>
            </div>
          ))}
        </div>
        
      </div>
     
  );
}

export default HomeScreen;
